import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {Box, Button, Container, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import BG from 'components/layout/BG';
import {Footer} from 'components/layout/Footer';
import Layout from 'components/layout/Layout';
import {useNavigate} from 'react-router-dom';
import Logo from 'assets/robot-logo.svg';

const ContentWrapper = styled(Box)({
	position: 'relative',
	textAlign: 'center',
	color: '#fff',
	padding: '2rem',
	backgroundColor: 'rgba(255, 255, 255, 0.1)',
	borderRadius: '16px',
	backdropFilter: 'blur(5px)',
	boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
});

export default function ErrorPage() {
	const navigate = useNavigate();
	const handleBackHome = () => navigate('/', {replace: true});
	const location = window.location.pathname.replace('/', '') || '404';

	return (
		<BG type="lightning">
			<Layout footer={Footer}>
				<Box width="100%" flexGrow={1} display="flex" alignItems="center" justifyContent="center">
					<Container maxWidth="sm">
						<ContentWrapper>
							<Box component="img" src={Logo} alt="Logo" width="150px" />

							<Typography variant="h1" component="h1" gutterBottom sx={{fontWeight: 'bold', fontSize: {xs: '3rem', md: '5rem'}}}>
								{location}
							</Typography>

							<Typography variant="h5" component="p" gutterBottom>
								{'Oops! Something went wrong.'}
							</Typography>

							<Typography variant="body1" sx={{mb: 3}} whiteSpace="pre-wrap">
								{'It seems you’ve wandered off the financial path.\nLet’s get you back on track.'}
							</Typography>

							<Button
								variant="contained"
								color="primary"
								size="large"
								onClick={handleBackHome}
								sx={{
									backgroundColor: '#FFD700',
									color: '#000',
									'&:hover': {backgroundColor: '#FFC107'},
								}}
							>
								Return to Home
							</Button>
						</ContentWrapper>
					</Container>
				</Box>
			</Layout>
		</BG>
	);
}
